/**
 * «Выберите ДВА» (mc_multi) — ответ как на бланке IELTS (20.10.2026, T5, решение владельца).
 *
 * ⚠️ ЖИВОЙ БАГ ТРЕНАЖЁРА. Тренажёр показывал mc_multi радиокнопками: ученик мог отметить
 * только один вариант, а сервер сверяет набор (`gradeOne` → equalSet) — такой вопрос не
 * засчитывался НИКОГДА. Теперь — флажки, ровно столько, сколько просит задание (2), значение —
 * варианты через « || » по алфавиту, как в моке. Лишнюю галочку не даём; сервер всё равно
 * снимает балл за лишний вариант (`gradePoints`).
 */
export const MULTI_PICK = 2;

/** Отмеченные варианты из значения ответа. */
export function multiChosen(value: string | undefined): string[] {
  return value ? value.split('||').map((s) => s.trim()).filter(Boolean) : [];
}

/** Нажатие на вариант: снять, если отмечен; добавить, если ещё есть место. */
export function multiToggle(value: string | undefined, option: string, max = MULTI_PICK): string {
  const chosen = multiChosen(value);
  if (chosen.includes(option)) return chosen.filter((c) => c !== option).sort().join(' || ');
  if (chosen.length >= max) return chosen.sort().join(' || ');
  return [...chosen, option].sort().join(' || ');
}

/** Вариант недоступен: места нет, а он не отмечен. */
export function multiFull(value: string | undefined, option: string, max = MULTI_PICK): boolean {
  const chosen = multiChosen(value);
  return !chosen.includes(option) && chosen.length >= max;
}
